import { IModalWarningSchema as IAlertModalWarning } from '../repositories/chats/entities/spam_modal_warning/ModalWarningSchema';

export enum EAlert {
  Spam = 'spam',
  Archive = 'archive',
  Info = 'info',
  FileUploadError = 'fileUploadError',
  MessageHasLinkToAnotherService = 'messageHasLinkToAnotherService',
  MessageСontainsForbiddenText = 'messageСontainsForbiddenText',
  NotFoundChat = 'notFoundChat',
}

export enum EFileError {
  Size = 'Размер файла слишком большой, попробуйте выбрать другой',
  Type = 'Неподдерживаемый тип файла, попробуйте выбрать другой',
}

export type TAlertButton = {
  text: string;
  onClick: () => void;
};

export interface IAlertState {
  isVisible: boolean;
  message?: string;
  type?: EAlert;
  chatId?: string;
  modalWarning?: IAlertModalWarning;
  button?: TAlertButton;
}

export type { IAlertModalWarning };
